function _0x4911(_0x75ae06, _0xa4e9fe) {
  const _0x590eab = _0x590e();
  return (
    (_0x4911 = function (_0x491164, _0x22cf51) {
      _0x491164 = _0x491164 - 0x1dd;
      let _0x30866a = _0x590eab[_0x491164];
      return _0x30866a;
    }),
    _0x4911(_0x75ae06, _0xa4e9fe)
  );
}
(function (_0x5d7cc2, _0x3eac99) {
  const _0xd9cda8 = _0x4911,
    _0x85d3a5 = _0x5d7cc2();
  while (!![]) {
    try {
      const _0x553c39 =
        (-parseInt(_0xd9cda8(0x1dd)) / 0x1) * (-parseInt(_0xd9cda8(0x1e4)) / 0x2) +
        -parseInt(_0xd9cda8(0x1ef)) / 0x3 +
        parseInt(_0xd9cda8(0x1e6)) / 0x4 +
        parseInt(_0xd9cda8(0x1df)) / 0x5 +
        (-parseInt(_0xd9cda8(0x1de)) / 0x6) * (-parseInt(_0xd9cda8(0x1e7)) / 0x7) +
        -parseInt(_0xd9cda8(0x1e1)) / 0x8 +
        (parseInt(_0xd9cda8(0x1ed)) / 0x9) * (-parseInt(_0xd9cda8(0x1ee)) / 0xa);
      if (_0x553c39 === _0x3eac99) break;
      else _0x85d3a5['push'](_0x85d3a5['shift']());
    } catch (_0x176bea) {
      _0x85d3a5['push'](_0x85d3a5['shift']());
    }
  }
})(_0x590e, 0xa0b58);
export default function getCurrentTime() {
  const _0x14a9c0 = _0x4911,
    _0x72f54b = new Date(),
    _0x542fc3 = _0x72f54b[_0x14a9c0(0x1e5)]()['toString']()[_0x14a9c0(0x1e0)](-0x2),
    _0x156949 = (_0x72f54b[_0x14a9c0(0x1e8)]() + 0x1)['toString']()['padStart'](0x2, '0'),
    _0x28af4f = _0x72f54b[_0x14a9c0(0x1ec)]()[_0x14a9c0(0x1eb)]()[_0x14a9c0(0x1e3)](0x2, '0'),
    _0x48b00b = _0x72f54b[_0x14a9c0(0x1e9)]()[_0x14a9c0(0x1eb)]()[_0x14a9c0(0x1e3)](0x2, '0'),
    _0x3394aa = _0x72f54b[_0x14a9c0(0x1e2)]()[_0x14a9c0(0x1eb)]()[_0x14a9c0(0x1e3)](0x2, '0'),
    _0x56f422 = _0x72f54b[_0x14a9c0(0x1ea)]()[_0x14a9c0(0x1eb)]()[_0x14a9c0(0x1e3)](0x2, '0');
  return '' + _0x56f422 + _0x3394aa + _0x48b00b + _0x28af4f + _0x156949 + _0x542fc3;
}
function _0x590e() {
  const _0x5b3c98 = [
    '862776IFajHX',
    '603164vsasDt',
    '12cbwzjy',
    '2181910vSxiNh',
    'substr',
    '3991560bIMnuW',
    'getMinutes',
    'padStart',
    '2ouEsWX',
    'getFullYear',
    '2517884vIIskf',
    '2833502VEcaBL',
    'getMonth',
    'getHours',
    'getSeconds',
    'toString',
    'getDate',
    '221526rJziHh',
    '420DxotZX',
  ];
  _0x590e = function () {
    return _0x5b3c98;
  };
  return _0x590e();
}
